import React, { Component, Dispatch } from 'react';
import { LoginService } from '../../api/login-service';
import { Common } from '../../core/common';
import { IAction, IAppState, IAuthInformation } from '../../models/action/core';
import { Log } from 'ng2-logger';
import { connect } from 'react-redux';
import { IExternalLoginObsProps } from '../../models/pages/login';
import * as Actions from '../../store/actions/login';
import * as CoursePageActions from '../../store/actions/coursePage';
import { withRouter } from 'react-router-dom';
import queryString from 'querystring';
import { UserType } from '../../models/enums/userType';

let _loginService: LoginService;
let _common: Common;
const _logger = Log.create('external-login-obs.tsx');
let _classId = '';
let _courseId = '';
let _returnUrl = '';

export class ExternalLoginObs extends React.Component<IExternalLoginObsProps, any> {
    state = { loginToken: '' };


    constructor(props: IExternalLoginObsProps) {
        super(props);
        _loginService = new LoginService();
        _common = new Common();
        this.callback.bind(this);
        this.loginActionBeforeGetLoginInformation.bind(this);

        const urlString = window.location.href;
        const url = new URL(urlString);

        const queryStringReturnUrl = url.searchParams.get('returnUrl');
        if (queryStringReturnUrl) {
            _returnUrl = queryStringReturnUrl!;
            const params = queryString.parse(queryStringReturnUrl!.substring(queryStringReturnUrl!.indexOf('?') + 1));
            _classId = params.classId ? String(params.classId) : '';
            _courseId = params.activityId ? String(params.activityId) : '';
        }
    }

    componentDidMount() {
        const urlString = window.location.href;
        const url = new URL(urlString);
        const queryStringToken = url.searchParams.get('token');
        this.setState({ loginToken: queryStringToken! });

        this.props.dispatch(Actions.getPageData(this.loginActionBeforeGetLoginInformation));
    }

    callback = () => {

        if (this.props.isLogin) {
            if (_returnUrl) {
                this.props.history.push('/' + _returnUrl);
            } else {
                if(this.props.userType === UserType.Admin)
                {
                    this.props.history.push('/almsp/u/Home/Cockpit');
                }
                else{
                    this.props.history.push('/almsp/u/Home/Index');
                }
            }

        } else {
            this.props.history.push('/almsp');
        }
    }

    courseCallBack = () => {

        if (_classId) {
            this.props.dispatch(CoursePageActions.getCourseContentMenu(_classId, _courseId ?? '', '', false, 'getCourseContentMenu', 'get', this.courseContentMenuCallBack));
        } else {
            this.courseContentMenuCallBack();
        }
    }

    courseContentMenuCallBack = () => {

        if (_classId) {
            this.props.dispatch(CoursePageActions.getCoursePageHeaderInformationData(_classId, _courseId, 'getCoursePageHeaderInformationData', 'get', this.callback));
        } else {
            this.callback();
        }
    }

    loginActionBeforeGetLoginInformation = () => {
        if (this.state.loginToken!) {

            this.props.dispatch(Actions.clickExternalLoginOBS(this.state.loginToken, '', 'get', this.callback));
        }
    }

    public render() {

        return (
            <div />
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IExternalLoginObsProps): any => {
    if (!state) {
        return state;
    }

    const returnProps: IExternalLoginObsProps = Object.assign({}, ownProps, {
        isLogin: state.login.identitiy.isLogin,
        userType: state.login.identitiy.userType
    });
    return returnProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => ({
    dispatch
});

const CExternalLoginObs = connect(
    mapStateToProps,
    dispatchProps
)(ExternalLoginObs);


export default withRouter(CExternalLoginObs);
